/**
 * PasskeyClient factory (task 7.1: ceremony methods, task 7.2: management methods)
 *
 * `@auth/client` の `ApiClient` を inject 経由で受け、ceremony method
 * (`registerPasskey` / `signInWithPasskey`) と management method
 * (`listPasskeys` / `deletePasskey` / `renamePasskey`) を組立てる。
 * feature-detect (task 7.3) は後続タスクでこのファクトリに slot-in する。
 */
import { registerPasskey } from "./ceremony/register-ceremony.js";
import { signInWithPasskey } from "./ceremony/signin-ceremony.js";
import { createWebAuthnBridge } from "./ceremony/webauthn-bridge.js";
import { deletePasskey } from "./management/delete-passkey.js";
import { listPasskeys } from "./management/list-passkeys.js";
import { renamePasskey } from "./management/rename-passkey.js";
/**
 * PasskeyClient を生成する。
 */
export function createPasskeyClient(deps) {
    const { apiClient, tokenStorage } = deps;
    const webAuthnBridge = deps.webAuthnBridge ?? createWebAuthnBridge();
    return {
        registerPasskey(input) {
            return registerPasskey(apiClient, webAuthnBridge, input);
        },
        signInWithPasskey(input) {
            return signInWithPasskey(apiClient, webAuthnBridge, tokenStorage, input);
        },
        listPasskeys() {
            return listPasskeys(apiClient);
        },
        deletePasskey(credentialId) {
            return deletePasskey(apiClient, credentialId);
        },
        renamePasskey(credentialId, label) {
            return renamePasskey(apiClient, credentialId, label);
        },
    };
}
//# sourceMappingURL=PasskeyClient.js.map